import { co2 } from './common';

export default {
  'consumption.co2': `Kombinált ${co2} kibocsátás`,
  'consumption.energy': 'Kombinált áramfogyasztás',
  'consumption.fuel': 'Kombinált üzemanyag-fogyasztás',
  'footnotes.local': '',
  'footnotes.wltp':
    'Az értékek a Bizottság (EU) 2017/1151 rendeletének XXI. mellékletében meghatározott WLTP mérési módszer alapján kerültek meghatározásra. Az üzemanyag-fogyasztási értékek kiszámítása ezen értékek alapján történt. Az adatok nem egy adott gépjárműre vonatkoznak, és nem képezik ajánlat részét, hanem kizárólag a különböző gépjárműtípusok egymással való összehasonlítására szolgálnak. Az értékek a kiválasztott extrafelszereltségek függvényében változnak.',
  'footnotes.nedc': '',
  'footnotes.emissions.appendix': '',
  'search.input.label': 'Keresett kifejezés / OnlineCode',
  'search.result.buy-online': 'Buy Online',
  'search.results': 'Nincs találat | {count} keresési eredmény | {count} Keresési eredmények',
  'search.results.backup': 'Nem található pontos egyezés. Kapcsolódó oldalak megtekintése:',
  'search.results.count': '{count} Keresési eredmények',
  'search.results.none.summary':
    'Nincs elérhető keresési eredmény ehhez a keresési kifejezéshez. Kérjük, próbálja meg újra egy másik kifejezéssel.',
  'search.show-more': 'További találatok',
  'search.unavailable': 'A keresés jelenleg nem érhető el.',
  'search.result.new': 'Új',

  'input.placeholder': 'Keresett kifejezés / OnlineCode',

  'suggestions.all_search_results': 'Összes ker. eredm',
  'suggestions.all_search_results_for': 'Össszes eredmény ehhez',
  'suggestions.in': 'itt:',

  all: 'Összes',
  UCOS: 'Mercedes-Benz használt gépjárművek',
  PASSENGER_CARS: 'Személygépkocsik',
  VANS: 'Kishaszonjárművek',
  NCOS: 'Mercedes-Benz online showroom',
  VIDEO: 'Videók',
  DEALER_LOCATOR: 'Márkaképviselet keresése',
  CONFIGURATOR: 'Konfigurátor',
  TEST_DRIVE: 'Tesztvezetés',
  VEHICLE_SEARCH: 'Gépjármű keresés',
  COLLECT: 'Kollekció és tartozékok',
  CONNECT: 'Mercedes me Store',
  ACCESSORIES: 'Biltilbehør',

  'search.result.consumption': 'Fogyasztás',
  'watch.video': 'Videó megtekintése',
  'input.recently': 'Legutóbbi keresés',
  'input.help.title': 'Mi alapján kereshet?',
  'input.help.text':
    'Keressen gépkocsitípusok, modellek, konfigurációkódok vagy tartozékok, egyéb termékek és információk használatával',

  // No results found
  'support.check': 'Kérjük, ellenőrizze, hogy nincs-e elírás, vagy próbálja újra egy másik kifejezéssel.',
  'support.no.results': 'Nincsenek találatok erre a kifejezésre.',
  'support.no.results.term': 'Nincsenek találatok',
  'support.chat': 'Nem találja, amit keres? Kérjük, használja az',
  'support.chat.with.us': 'online chates támogatást',

  'search.results.offer': 'Népszerű ajánlatok "{query}" számára',
};
